
const form = document.getElementById('reset-form');
form.addEventListener('submit', (e) => {
  e.preventDefault();
  e.stopPropagation();
  const email = document.getElementById('email').value.trim();
  if (!email) return;
  document.getElementById('reset-email').textContent = email;
  form.hidden = true;
  document.querySelector('.auth-divider').hidden = true;
  document.getElementById('reset-success').hidden = false;
});
